module.exports = __webpack_public_path__ + "img/pr2.90044561.jpg";